export default __webpack_public_path__ + "static/media/bird.a3a08ed6.gif";